import React from "react";
import { hydrate } from "react-dom";
import queryString from "query-string";

import IntlProvider from "../shared/i18n/IntlProvider";
import GlobalHeader from "../shared/components/GlobalHeader";
import GlobalFooter from "../shared/components/GlobalFooter";
import Prototype from "../shared/components/Prototype";

// Find the component elements for mounting
const globalHeaderContainer = document.getElementById("global-header");
const globalFooterContainer = document.getElementById("global-footer");
const prototypeContainer = document.getElementById("prototype");

const urlParams = queryString.parse(window.location.search);
const locale = urlParams.locale || "en-US";

// Mount the Global Header if the container exists on the page.
if (globalHeaderContainer) {
  const props = window.GLOBAL_UI_INITIAL_PROPS;
  hydrate(
    <IntlProvider initialLanguage={locale}>
      <GlobalHeader {...props} />
    </IntlProvider>,
    globalHeaderContainer
  );
}

// Mount the Global Footer if the container exists on the page.
if (globalFooterContainer) {
  hydrate(
    <IntlProvider initialLanguage={locale}>
      <GlobalFooter />
    </IntlProvider>,
    globalFooterContainer
  );
}

// Mount the Prototype if the container exists on the page.
if (prototypeContainer) {
  hydrate(
    <IntlProvider initialLanguage={locale}>
      <Prototype />
    </IntlProvider>,
    prototypeContainer
  );
}

// Hot reload the modules on file changes.
if (process.env.NODE_ENV === "development") {
  if (module.hot) {
    module.hot.accept();
  }
}
